export default {
  description: {
    id: 'bo_seller_customer_reviews_no_result_description',
    defaultMessage:
      'Focus on listing quality items, and watch the glowing reviews come pouring in.',
  },
  title: {
    id: 'bo_seller_customer_reviews_no_result_title',
    defaultMessage: 'No customer reviews yet.',
  },
}
